export default "__VITE_ASSET__15e5bbfc__"